import { createContext, useState, useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import useAuth from "../hooks/useAuth";
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import  secureLocalStorage  from  "react-secure-storage";

const ConsultaContext = createContext()

const client = axios.create({
  baseURL: "https://appsexpedientemedico.azurewebsites.net/api"
});

const ConsultaProvider = ({ children }) => {

  const navigate = useNavigate()
  // eslint-disable-next-line
  const { validarToken, guidCita } = useAuth()

  const [bandUltDiagn, setBandUltDiagn] = useState(false)

  // eslint-disable-next-line
  const [loadTime, setLoadTime] = useState(false)
  const [exito, setExito] = useState(false)
  // eslint-disable-next-line
  const [alergiasCatalogo, setAlergiasCatalogo] = useState([
    {
      alGuid: uuidv4(),
      alNombre: 'Ácido acetilsalicilico'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Paracetamol'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Frutos secos'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Gluten'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Huevo'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Leche y/o productos lácteos'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Penicilina'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Pescado'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Polvo'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Soya'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Ibuprofeno'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Diclofenaco'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Ciprofloxacino'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Trimetroprim/Sulfametoxazol'
    },
    {
      alGuid: uuidv4(),
      alNombre: 'Polén'
    },
  ])

  const [diagnosticoCatalogo, setDiagnosticoCatalogo] = useState([
    /*{
      diGuid: uuidv4(),
      diNombre: 'Diagnostico 1'
    },
    {
      diGuid: uuidv4(),
      diNombre: 'Diagnostico 2'
    },
    {
      diGuid: uuidv4(),
      diNombre: 'Diagnostico 3'
    }*/
  ])
  const [diagnosticoCatalogo2, setDiagnosticoCatalogo2] = useState([])

  const [medicamentoCatalogo, setMedicamentoCatalogo] = useState([
    {
      mGuid: "8132010A-3E4F-47B3-A441-5870D15AC172",
      mNombre: 'ÁCIDO ACETILSALICÍLICO',
      mPresentacion: 'TABLETA',
      mCantidad: '500 MG',
      mCategoria: 'ANALGÉSICO'
    },
    {
      mGuid: "F0703F98-93CE-4F27-8A11-D954FD0C8B47",
      mNombre: 'ÁCIDO ACETILSALICÍLICO',
      mPresentacion: 'TABLETA EFERVESCENTE',
      mCantidad: '500 MG',
      mCategoria: 'ANALGÉSICO'
    }
  ])

  const [alergiaSeleccionada, setAlergiaSeleccionada] = useState({
    alGuid: '',
    alNombre: ''
  })
  const [diagnosticoSeleccionada, setDiagnosticoSeleccionada] = useState({
    diGuid: '',
    diNombre: ''
  })
  const [medicamentoSeleccionado, setMedicamentoSeleccionado] = useState(
    {
      nombreMedicamento: '',
      medGuid: '',
      cantidadDosis: '',
      tiempoDosis: '',
      indicacionesA: ''
    }
  )
  const [alergiaW, setAlergiaW] = useState('')

  const handleChangeMedicamento = (e, f, g) => {
    setMedicamentoSeleccionado({
      ...medicamentoSeleccionado,
      nombreMedicamento: e,
      medGuid: f,
      medAdministracion: g
    })
  }
  const handleChangeMedicamento2 = (e) => {
    setMedicamentoSeleccionado({
      ...medicamentoSeleccionado,
      [e.target.name]: e.target.value
    })
  }

  const [datos, setDatos] = useState({
    medicoNombre: '',
    medicoPApellido: '',
    medicoSApellido: '',
    medicoTitulo: '',
    medicoCedula: '',
    medicoFechaCita: '',
    medicoTelefono: '',
    medicoUnidadTrabajo: '',
    medicoUniv: '',
    medicoFirma: '',
    pacienteNombre: '',
    pacientePApellido: '',
    pacienteSApellido: '',
    pacienteEdad: 25,
    pacienteTa: '',
    pacienteFrecCar: '',
    pacienteFrecResp: '',
    pacienteSato: '',
    pacienteTemp: '',
    pacientePeso: '',
    pacienteTalla: '',
    pacienteAlergias: '',
    pacienteIDX: 'String',
    pacienteExploracion: '',
    pacienteLaboratorio: '',
    pacienteIMC: '',
    pacientePlan: '',
    sintomas: [],
    medicamentos: [],
    alergias: [],
    diagnosticos: [],
    reRecomendaciones:''
  })
  const {
    pacienteEdad,
    pacienteTa,
    pacienteFrecCar,
    pacienteFrecResp,
    pacienteSato,
    pacienteTemp,
    pacientePeso,
    pacienteTalla,
    pacienteIMC,
    pacienteIDX,
    pacienteExploracion,
    pacienteLaboratorio,
    pacientePlan,
    medicamentos,
    alergias,
    diagnosticos,
    sintomas,
    medicoFirma,
    reRecomendaciones
  } = datos

  const [error, setError] = useState({
    band: false,
    texto: ''
  })

  const [bandSintomas, setBandSintomas] = useState(false)

  const handleChangeDatos = (e) => {



    if (e.target.name === 'pacienteTalla') {
      //alert('1')
      setDatos({
        ...datos,
        pacienteIMC: parseFloat(pacientePeso / ((e.target.value) * (e.target.value))).toFixed(2),
        [e.target.name]: e.target.value
      })
      const datos2 = {
        ...datos,
        pacienteIMC: parseFloat(pacientePeso / ((e.target.value) * (e.target.value))).toFixed(2),
        [e.target.name]: e.target.value
      }
      localStorage.setItem('jsonexpmed', JSON.stringify(datos2))
    } else if (e.target.name === 'pacientePeso') {
      //alert('2')
      setDatos({
        ...datos,
        pacienteIMC: parseFloat(e.target.value / ((pacienteTalla) * (pacienteTalla))).toFixed(2),
        [e.target.name]: e.target.value
      })
      const datos2 = {
        ...datos,
        pacienteIMC: parseFloat(e.target.value / ((pacienteTalla) * (pacienteTalla))).toFixed(2),
        [e.target.name]: e.target.value
      }
      localStorage.setItem('jsonexpmed', JSON.stringify(datos2))
    } else {
      setDatos({
        ...datos,
        [e.target.name]: e.target.value
      })
      const datos2 = {
        ...datos,
        [e.target.name]: e.target.value
      }
      localStorage.setItem('jsonexpmed', JSON.stringify(datos2))
    }
  }



  const getDetallesCita = async (e) => {
    try {

      setLoadTime(true)
      validarToken()
      let tokens = secureLocalStorage.getItem('tokenid');

      let json = localStorage.getItem('jsonexpmed')
      const json2 = JSON.parse(json)

      const response = await client.get(`/citas/citaDetail?cGuid=${e}`, {
        headers: {
          Authorization: `Bearer ${secureLocalStorage.getItem('tokenid')}`,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
          'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          'Content-Type': 'application/json',
        }
      })

      setDatos({
        ...datos,
        pacienteNombre: response.data.response.paciente.userNombre,
        pacientePApellido: response.data.response.paciente.userPApellido,
        pacienteSApellido: response.data.response.paciente.userSApellido,
        pacienteEdad: response.data.response.paciente.userAge,
        pacienteTa: json2 != null ? json2.pacienteTa : '',
        medicoNombre: response.data.response.medico.userNombre,
        medicoPApellido: response.data.response.medico.userPApellido,
        medicoSApellido: response.data.response.medico.userSApellido,
        medicoTitulo: response.data.response.detallesMedico.medTitulo,
        medicoCedula: response.data.response.detallesMedico.medCedula,
        medicoUniv: response.data.response.detallesMedico.medUniversidad,
        medicoLogo: response.data.response.detallesMedico.medLogo,
        medicoFechaCita: response.data.response.cita.cDcita.split('T')[0],
        medicoTelefono: response.data.response.medico.userPhone,
        medicoUnidadTrabajo: response.data.response.unidadTrabajo,
        medicoFirma: response.data.response.detallesMedico.medFirma,
        medicoDireccion: response.data.response.direccion,
        pacienteFrecCar: json2 != null ? json2.pacienteFrecCar : '',
        pacienteFrecResp: json2 != null ? json2.pacienteFrecResp : '',
        pacienteSato: json2 != null ? json2.pacienteSato : '',
        pacienteTemp: json2 != null ? json2.pacienteTemp : '',
        pacientePeso: json2 != null ? json2.pacientePeso : '',
        pacienteTalla: json2 != null ? json2.pacienteTalla : '',
        pacienteAlergias: json2 != null ? json2.pacienteAlergias : '',
        pacienteIDX: json2 != null ? json2.pacienteIDX : '',
        pacienteExploracion: json2 != null ? json2.pacienteExploracion : '',
        pacienteLaboratorio: json2 != null ? json2.pacienteLaboratorio : '',
        pacienteIMC: json2 != null ? json2.pacienteIMC : '',
        pacientePlan: json2 != null ? json2.pacientePlan : '',
        sintomas: json2 != null ? json2.sintomas : [],
        medicamentos: json2 != null ? json2.medicamentos : [],
        alergias: json2 != null ? json2.alergias : [],
        diagnosticos: json2 != null ? json2.diagnosticos : [],
        ultimoDiagnostico: response.data.response.uDiagnostico
      })
      /*
      const responseAlergias = await client.get(`/alergia/all?token=${tokens}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
          'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          'Content-Type': 'application/json',
        }
      })
      setAlergiasCatalogo(responseAlergias.data.response);
      */
     
      const responseDiagnostico = await client.get(`/diagnostico/all`, {
        headers: {
          Authorization: `Bearer ${secureLocalStorage.getItem('tokenid')}`,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
          'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          'Content-Type': 'application/json',
        }
      })
      setDiagnosticoCatalogo(responseDiagnostico.data.response);
      const arrayFilter = responseDiagnostico.data.response.map(e => ( { value: e.diGuid, label: e.diNombre }))
      setDiagnosticoCatalogo2(arrayFilter)
      
      const responseMedicamentos = await axios.get(`https://appsexpedientemedico.azurewebsites.net/all`, {
        headers: {
          Authorization: `Bearer ${secureLocalStorage.getItem('tokenid')}`,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
          'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          'Content-Type': 'application/json',
        }
      })
      setMedicamentoCatalogo(responseMedicamentos.data.response);
      
      setLoadTime(false)
    } catch (e) {
      setLoadTime(false)

      setError({ band: true, texto: e.response.data.response })
    }
  }

  const crearCita = async () => {
    try {
      setLoadTime(true)
      validarToken()
      let tokens = secureLocalStorage.getItem('tokenid');
      
      const medicamentos2 = medicamentos.map(e => ({ medGuid: e.medGuid, reMedCantidadDosis: e.cantidadDosis, reMedTiempoDosis: e.tiempoDosis, ReMedIndicacionA: e.indicacionesA }))

      const alergias2 = alergias.map(e => ({ alNombre: e.alNombre }))

      const diagnosticos2 = diagnosticos.map(e => ({ diGuid: e.diGuid }))


      const sintomas2 = sintomas.map(e => ({ sintomanombre: e.sintomanombre }))

      const json = {
        // "token": tokens,
        "citaGuid": guidCita,
        "userEdad": pacienteEdad,
        "ta": pacienteTa + " mmHg",
        "sintomas": "string",
        "frecCar": pacienteFrecCar + " lpm",
        "frecResp": pacienteFrecResp + " rpm",
        "sato": pacienteSato + " %",
        "temp": pacienteTemp + " °C",
        "peso": pacientePeso + " Kg",
        "talla": pacienteTalla + " mts",
        "imc": parseFloat(pacienteIMC).toString(),
        "idx": pacienteIDX,
        "diagnostico": "string",
        "expFisLab": pacienteExploracion,
        "reExpLab":pacienteLaboratorio,
        "plan": pacientePlan,
        "firma": medicoFirma,
        "medicamentosList": {
          "medicamentos": medicamentos2
        },
        "alergiasList": {
          "alergias": alergias2
        },
        "diagnosticoList": {
          "diagnosticos": diagnosticos2
        },
        "sintomasList": {
          "sintoma": sintomas2
        },
        "reRecomendaciones": reRecomendaciones
      }
      
      var alergiasJoin = ''
      for(var i = 0; i < alergias2.length; i++){
        alergiasJoin+= i === alergias2.length-1 ? alergias2[i].alNombre: alergias2[i].alNombre+','
      }
      const json2 = {
        ...datos,
        pacienteTa: datos.pacienteTa + " mmHg",
        pacienteFrecCar: datos.pacienteFrecCar + " lpm",
        pacienteFrecResp: datos.pacienteFrecResp + " rpm",
        pacienteSato: datos.pacienteSato + " %",
        pacienteTemp: datos.pacienteTemp + " °C",
        pacientePeso: datos.pacientePeso + " Kg",
        pacienteTalla: datos.pacienteTalla + " mts",
        alergiasJoin: alergiasJoin        
      }

      localStorage.setItem('jsonexpmed2', JSON.stringify(json2))
      

      console.log(json);
      const response = await client.post(`/recetass/create`, json, {
        headers: {
          Authorization: `Bearer ${secureLocalStorage.getItem('tokenid')}`,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE',
          'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          'Content-Type': 'application/json',
        }
      })

      navigate('/receta')
      
      setLoadTime(false)
      setExito(true)
    } catch (e) {
      console.log(e);
      setLoadTime(false)

    }
  }


  useEffect(() => {
    if (exito) {
      navigate('/medico')
    }
  }, [exito])

  useEffect(() => {


  }, [datos])

  return (
    <ConsultaContext.Provider
      value={{
        setError,
        error,
        loadTime,
        handleChangeDatos,
        datos,
        setBandSintomas,
        bandSintomas,
        setDatos,
        alergiasCatalogo,
        setAlergiaSeleccionada,
        alergiaSeleccionada,
        diagnosticoCatalogo,
        setDiagnosticoSeleccionada,
        diagnosticoSeleccionada,
        medicamentoCatalogo,
        medicamentoSeleccionado,
        handleChangeMedicamento,
        handleChangeMedicamento2,
        setMedicamentoSeleccionado,
        getDetallesCita,
        crearCita,
        setBandUltDiagn,
        bandUltDiagn,
        alergiaW,
        setAlergiaW,
        diagnosticoCatalogo2
      }}
    >
      {children}
    </ConsultaContext.Provider>
  )
}

export {
  ConsultaProvider
}

export default ConsultaContext